<script lang="ts">
	import { onDestroy } from 'svelte';
	export let containerClass: string = ''; // So that setting dimensions on the parent will propagate
	export let value: number; // Initial value
	export let setValue = (_: number) => {}; // Callback to update the value
	export let min: number; // Min value
	export let max: number; // Max value
	export let name: string; // Name of the value
	export let suffix: string = '';
	export let step: number = 1;
	export let isFloat: boolean = false;
	export let isPercentage: boolean = false;
	export let title: string = '';
	export let heightClass: string = 'h-6'; // Tailwind height class
	export let textClass: string = 'text-xs'; // Tailwind text size class

	let isDragging: boolean = false; // To keep track if we are dragging
	let container: HTMLElement;
	let widthPercent: number = ((value - min) / (max - min)) * 100;
	$: widthPercent = ((value - min) / (max - min)) * 100;

	function handlePointerDown(event: PointerEvent): void {
		isDragging = true;
		window.addEventListener('pointermove', handlePointerMove);
		window.addEventListener('pointerup', handlePointerUp);
		window.addEventListener('pointercancel', handlePointerUp);
		window.addEventListener('blur', handlePointerUp);
		updateValue(event);
	}

	function handlePointerMove(event: PointerEvent): void {
		if (isDragging) {
			updateValue(event);
		}
	}

	function handlePointerUp(): void {
		if (!isDragging) return;
		isDragging = false;
		window.removeEventListener('pointermove', handlePointerMove);
		window.removeEventListener('pointerup', handlePointerUp);
		window.removeEventListener('pointercancel', handlePointerUp);
		window.removeEventListener('blur', handlePointerUp);
	}

	function updateValue(event: MouseEvent): void {
		const rect = container.getBoundingClientRect();
		let newValue: number = ((event.clientX - rect.left) / rect.width) * (max - min) + min;
		newValue = Math.round(newValue / step) * step;
		value = Math.min(max, Math.max(min, newValue));
		setValue(value);
	}
	onDestroy(handlePointerUp);
</script>

<div
	bind:this={container}
	class={`relative ${heightClass} border rounded select-none ${containerClass} cursor-pointer
		border-primary-200 hover:brightness-90
		dark:border-zinc-800 dark:hover:brightness-150`}
	role="slider"
	tabindex="0"
	aria-valuenow={value}
	on:pointerdown={handlePointerDown}
	{title}
>
	<div
		class={`h-full rounded-sm border-primary-200 bg-primary-200 dark:border-zinc-800 dark:bg-zinc-600 shadow-md`}
		style="width: {widthPercent}%"
	>
		<span
			class="absolute w-full h-full flex flex-row justify-center items-center {textClass}
				text-zinc-900
				dark:text-zinc-200"
		>
			<span class="w-fit">
				{#if !isDragging && name}
					{name}
				{:else if isPercentage}
					{(100 * value).toFixed(0)}{suffix}
				{:else if isFloat}
					{value.toFixed(2)}{suffix}
				{:else}
					{value}{suffix}
				{/if}
			</span>
		</span>
	</div>
</div>
